import { GlobalState } from "src/reducers";
import featureFlags from "./featureFlags";

export const selectFeatureFlags = (id: featureFlags | null) => (
    state: GlobalState
): boolean => {
    if (id === null) return false;
    return state.firebase.firestore.featureFlags[id];
};
